import { motion } from "motion/react";
import { createElement } from "react";
import { useWatch } from "react-hook-form";

import { cardVariants } from "@/constants/animations";
import { createNotificationRecipientTypes } from "@/constants/notificationRecipientTypes";
import { User } from "@/types/user.types";

import { CreateNotificationFormType } from "./CreateNotificationForm";
import CreateNotificationRecipientGroupSelector from "./CreateNotificationRecipientGroupSelector";
import CreateNotificationRecipientTabSelector from "./CreateNotificationRecipientTabSelector";
import CreateNotificationRecipientUserSelector from "./CreateNotificationRecipientUserSelector";

function CreateNotificationRecipients({ users, loading }: { users: User[]; loading: boolean }) {
    const activeType = useWatch<CreateNotificationFormType>({ name: "recipients.tab" });
    const operationComponents = [
        {
            value: createNotificationRecipientTypes.enum.user,
            path: "recipients.permissionGroupIds",
            comp: CreateNotificationRecipientUserSelector,
        },
        {
            value: createNotificationRecipientTypes.enum.permissionGroup,
            path: "recipients.userIds",
            comp: CreateNotificationRecipientGroupSelector,
        },
    ] as const;

    return (
        <div className="grid grid-cols-8 col-span-full gap-y-5 gap-x-10">
            <CreateNotificationRecipientTabSelector loading={loading} />
            {operationComponents.map(({ value, comp }, index) => {
                const isActive = activeType === value;

                return (
                    isActive && (
                        <motion.div
                            key={index}
                            variants={cardVariants}
                            animate="animate"
                            initial="initial"
                            layoutId="transport-info"
                            custom={index === 0}
                            transition={{ duration: 0.1, type: "tween" }}
                            exit="exit"
                            className="grid px-5  grid-cols-8 gap-y-5 gap-x-10 col-span-full"
                        >
                            {createElement(comp, { users })}
                        </motion.div>
                    )
                );
            })}
        </div>
    );
}

export default CreateNotificationRecipients;
